module.exports = __webpack_public_path__ + "img/OrganizersOffice.143ae7f0.gif";